export const refinementRemovedEventName = 'refinementRemoved';
export const refinementsClearedEventName = 'refinementsCleared';
export const cvsStore = 'p2r-cvs';
export const walgreenStore ='p2r-walgreens';
export const m2hStore ='m2h-online';
export const walmartStore ='p2r-walmart';
export const mocksitePhotoSourceUrl = ['https://upload.fujifilmesys.com','https://media2.ffvoyager.dev']
